import {StyleSheet} from "aphrodite";
import * as React from "react";

import BasePageTemplate, {
    type BasePageTemplateProps,
} from "./base-page-template.tsx";

/**
 * Provides the default template for a page on the site, including the header,
 * footer, and main content styles.
 */
const DefaultPageTemplate = ({
    children,
    ...restProps
}: BasePageTemplateProps): React.ReactElement => {
    return (
        <BasePageTemplate
            {...restProps}
            containerStyle={styles.wrapper}
            mainContentStyle={styles.mainContent}
        >
            {children}
        </BasePageTemplate>
    );
};

const styles = StyleSheet.create({
    wrapper: {
        display: "flex",
        flexDirection: "column",
        minHeight: "100%",
    },
    mainContent: {
        flex: "none",
        // NOTE(john): We set the min-height here to be 100vh so that we can push down the
        // footer to below the page fold, preventing as big of a jarring jump when the page
        // loads.
        minHeight: "100vh",
    },
});

export default DefaultPageTemplate;
